import { ApiFactory } from '@/plugins/api/logic/ApiFactory'
import { GetAvailableCurrency } from '@/plugins/api/logic/handbook/get-available-currency'

export class HandbookController extends ApiFactory {
  async getAvailableCurrency() {
    const request = new GetAvailableCurrency(this.context)
    return await request.fetch(this.axios)
  }
}
